import React, { useState } from "react";

import { Layout } from "@vwfs-bronson/bronson-react";
import { GoogleMap } from "../Map/GoogleMap";
import { InstallationForm } from "./InstallationForm";
import { isLiteSite } from "../../helpers/isLiteSite";

export const LandingInstallation = () => {
    const [installationComboSelected, setInstallationComboSelected] = useState();
    return (
        <Layout>
            <Layout.Item default="1/2" m="1/1">
                <InstallationForm
                    installationComboSelected={installationComboSelected}
                    setInstallationComboSelected={setInstallationComboSelected}
                ></InstallationForm>
            </Layout.Item>
            <Layout.Item default="1/2" m="1/1">
            {isLiteSite() ? (
                <img alt="sobre nosotros 1" src="/images/landing/porsche/concesionario-porsche.jpg" />): (
                <GoogleMap
                    installationComboSelected={installationComboSelected}
                    setInstallationComboSelected={setInstallationComboSelected}
                ></GoogleMap>)
            }
                
            </Layout.Item>
        </Layout>
    );
};
